//React
import { FunctionComponent } from "react";

//Selectors
import { useAppSelector } from "../../system/redux/hooks/redux-store-hooks";
import { selectAreaInfo } from "../redux/selectors/select-area-info";

//Util
import { isStringEmpty } from "drh-js-library/dist/drh-string-utils/is-string-empty";

const AreaInfo: FunctionComponent = () => {
	//State Values
	const areaInfo = useAppSelector(selectAreaInfo);

	//JSX

	//Do not show anything if the area info data is not available
	if (isStringEmpty(areaInfo?.AreaInfoContent)) {
		return null;
	}

	return (
		<section className="area-info panel">
			{!isStringEmpty(areaInfo?.Title) && <h2> {areaInfo?.Title} </h2>}
			<div
				className="area-blurb"
				dangerouslySetInnerHTML={{
					__html: areaInfo?.AreaInfoContent,
				}}
			/>
		</section>
	);
};

export default AreaInfo;
